import useSWR, { useSWRConfig } from "swr";
import React, { useState } from "react";
import FormModal from "../common/FormModal";
import Loading from "../common/Loading";
import { Form } from "react-bulma-components";
import { fetcher } from "../utils/fetch";

export default function AddExistingContactForm({ onClose, project, show }) {
    const { mutate } = useSWRConfig();
    const { data, error } = useSWR('/api/contacts', fetcher);

    const [association, setAssociation] = useState();
    const [contact, setContact] = useState();

    const onSubmit = async () => {
        try {
            await fetcher(`/api/projects/${ project.id }/contacts`, {
                method: 'POST',
                body: JSON.stringify({
                    association: association,
                    contact: {
                        id: contact
                    }
                })
            });

            await mutate(`/api/projects/${ project.id }`);
        } catch (e) {
            // TODO: Check for validation errors
            // TODO: Check for catastrophic failures
            console.error('oops', e);
        }

        onClose();


        const errorResponse = {
            "field": [
                'one validation message',
                'two validation message'
            ]
        };
    };

    return (
        <FormModal title="Add existing contact" onSubmit={ onSubmit } onClose={ onClose } show={ show }>
            {/* TODO: Loading */ }
            <Loading loading={ !data || error }>
                <Form.Field horizontal>
                    <Form.Field.Label>
                        <Form.Label>Contact</Form.Label>
                    </Form.Field.Label>
                    <Form.Field.Body>
                        <Form.Field>
                            <Form.Control>
                                <Form.Select onChange={ e => setContact(e.currentTarget.value) }>
                                    <option/>
                                    {
                                        (data || []).map(contact => (
                                            <option key={ contact.id } value={ contact.id }>
                                                { contact.name }
                                            </option>
                                        ))
                                    }
                                </Form.Select>
                            </Form.Control>
                        </Form.Field>
                    </Form.Field.Body>
                </Form.Field>
                <Form.Field horizontal>
                    <Form.Field.Label>
                        <Form.Label>Association</Form.Label>
                    </Form.Field.Label>
                    <Form.Field.Body>
                        <Form.Field>
                            <Form.Control>
                                <Form.Input onChange={ e => setAssociation(e.currentTarget.value) }/>
                            </Form.Control>
                        </Form.Field>
                    </Form.Field.Body>
                </Form.Field>
            </Loading>
        </FormModal>
    )
}
